import { makeStyles } from "@mui/styles";
import { primaryColor } from "../../../../constants/colors";

const restaurantStyle = makeStyles((theme) => ({
  loginBtn: {
    "&.MuiButton-root": {
      backgroundColor: primaryColor,
      width: "80%",
      padding: "10px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#e21b70",
      },
    },
  },
  loginBtnText: {
    fontSize: "13px !important",
    textTransform: "none",
    fontWeight: "500 !important",
  },
  restSwitch: {
    "&.MuiFormControlLabel-root .MuiSwitch-root .MuiSwitch-track": {
      backgroundColor: primaryColor
    },
    "&.MuiFormControlLabel-root .MuiSwitch-root .MuiSwitch-switchBase": {
      color: primaryColor,
    },
  },
  globalSelectStyle: {
    width: "100%",
    "&.MuiFormControl-root .MuiInputBase-root .MuiSelect-select": {
      padding: "8px 12px !important",
      fontSize: "12px !important",
    },
    "&.MuiFormControl-root .MuiInputBase-root input": {
      fontSize: "12px !important",
    },
  },
  globalInputLabel: {
    fontSize: "13px !important",
    margin: "5px 0",
  },
}));

export default restaurantStyle;
